<template>
    <div class="right-wrap">
        <div class="fixBox">
            <a href="https://merchant.wishpay-global.com/#/login" target="_blank" class="fix-btn fixA phoneHide">商家入口</a>
            <a href="https://agent.wishpay-global.com/#/login" target="_blank" class="fix-btn fixA phoneHide">合作夥伴入口</a>
            <div class="fix-btn">
                <a href="tel:85236187626">
                    <img src="../../assets/img/phone.png" class="fixImg phoneHide">
                    <img src="../../assets/img/phone-h5.png" class="fixImg phoneImg pcHide" >
                </a>
                <span class="phoneHide">852-36187626</span>
            </div>
            <div class="fix-btn" @click="goTop">
                <img src="../../assets/img/top.png" class="fixImg">
                <span class="phoneHide">TOP</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'right',
  data () {
    return {}
  },
  mounted () {

  },
  methods: {
    goTop: function () {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    }
  }
}
</script>

<style scoped>
.fixBox{
    position: fixed;
    right: 10px;
    bottom:30px;
    background: #E5E5E5;
    width: 180px;
    z-index: 999
}
.fix-btn{
    width: 130px;
    margin: 10px auto;
    height: 40px;
    line-height: 40px;
    display: block;
    text-align: center;
}
.fixA{
    background: #ED6B1A;
    color: #ffffff;
}
.fixImg{
    width: 20px;
    height: 20px;
    vertical-align: middle;
}
.fix-btn span{
    color: #ED6B1A;
    display: inline-block;
    vertical-align: middle;
}
@media screen and (max-width: 1024px){
    .fixBox{
        position: fixed;
        right: 10px;
        bottom:30px;
        background: #E5E5E5;
        width: 50px;
        z-index: 999
    }
    .fix-btn{
        width: 50px;
        margin: 10px auto;
        height: 40px;
        line-height: 40px;
        display: block;
        text-align: center;
    }
    .phoneImg{
        display: inline!important;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/pc/right.vue